'use strict';

import './vdpConsumerReviewSection.scss';
import template from './vdpConsumerReviewSection.template.html';
import controller from './vdpConsumerReviewSection.controller.js';

const component = {
    bindings: {
        apiHost: "@",
        apiKey: "@",
        productId: "@",
        canonicalUrl: '@'
    },
    controller,
    template,
    transclude: true
};

export default component;